import { memo, useMemo } from 'react'
import useAppData from 'app/services/hooks/useAppData'
import Icon from 'components/core/Icon/Icon'
import Layout from 'components/core/Layout/Layout'
import Modal from 'components/interface/Modal/Modal'
import styles from './ModalLearnUtility.module.scss'

/**
 * The `ModalLearnCompatibility`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function ModalLearnCompatibility (props) {
  const appData = useAppData()
  const title = useMemo(() => <h1>About Utilities</h1>, [])

  return (
    <Modal.Container size="x-small">
      <Modal.Media size="small">
        <Icon icon="info" />
      </Modal.Media>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        <Layout.Body align="center">
          <div className={styles.list}>
            {appData?.utilities.map(({ description, icon, title }, i) => (
              <div className={styles.utility} key={i}>
                <div className={styles.thumbnail}>
                  <Icon icon={icon} />
                </div>
                <div className={styles.info}>
                  <h2>{title}</h2>
                  <p>{description}</p>
                </div>
              </div>
            ))}
          </div>
        </Layout.Body>
      </Modal.Body>
      <Modal.Footer />
    </Modal.Container>
  )
}

/** @type {object} */
ModalLearnCompatibility.propTypes = {}

/** @type {object} */
ModalLearnCompatibility.defaultProps = {}

// Memoize
export default memo(ModalLearnCompatibility)
